import { DataDialog } from "../components/dialogos/general/general-dialog.component";

export class DialogsConfig {


    
    public static dialogoConfigEsResidente: DataDialog = {
        centerContent: true,
        icon: 'exito.svg',
        title: 'De acuerdo con su(s)<br>respuesta(s), usted es<br>residente fiscal en<br>Colombia.',
        subtitle: 'Puede continuar con el <b>formulario 210</b> para cumplir con<br>sus obligaciones tributarias.', 
        content: '',
        textButtons: ``,
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Siguiente",
                class: "general-button-residente-fiscal",
                value: true
            }
        ]
    };

    public static dialogoConfigNoEsResidente: DataDialog = {
        centerContent: true,
        icon: 'exito.svg',
        title: 'De acuerdo con su(s)<br>respuesta(s), usted NO<br>es residente fiscal en<br>Colombia.',
        subtitle: `Realice su declaración en el <a href="${window.location.origin}/WebDilIngresoFormRenta110" class="link">formulario 110</a>`,
        content: '',
        textButtons: ``,
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Salir",
                class: "general-button-residente-fiscal",
                value: true
            }
        ]
    };

    public static dialogoConfigAlertaFactura: DataDialog = {
        centerContent: false,
        icon: '',
        title: "Declaración de renta sugerida",
        subtitle: "Año gravable 2022.",
        content: `<p>A partir de las validaciones realizadas en nuestro Sistema Integral de Información Tributaria, hemos identificado que no ha 
                presentado su declaración de renta en años anteriores. Lo invitamos a que realice la presentación oportuna de estas declaraciones; 
                teniendo en cuenta que, de no hacerlo, podrá traerle sanciones económicas y ser objeto de Facturación del Impuesto Sobre la Renta.</p>        
                <p>La DIAN,  con el ánimo de facilitar el proceso de preparación de la declaración de renta a personas naturales, y basados en la 
                información exógena reportada por terceros con corte al 14 julio 2023, ha puesto a su disposición la Declaración 
                Sugerida de Renta correspondiente al año gravable 2022. </p><br><div fxLayout="column" class="card-with-bg-blue"><b>Recuerde:</b><br><br><p style="margin-top: 10px">
                Es su responsabilidad revisarla en detalle y realizar las modificaciones necesarias para que corresponda con su realidad juridica, económica y 
                financiera.</p></div>`,
        textButtons: `<p class="text-buttons"><b>¿Desea consultar la declaración sugerida?</b></p>`,
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Si consultar",
                class: "general-button",
                value: true
            },
            {
                text: "No, gracias",
                class: "button-outline-border",
                value: false
            }
        ]
    };

    public static dialogoConfigNoAlertaFactura: DataDialog = {
        centerContent: false,
        icon: '',
        title: "Declaración de renta sugerida",
        subtitle: `Año gravable `,
        content: `<p>La DIAN, con el ánimo de facilitar el proceso de preparación de la declaración de renta a personas naturales, 
        basados en la información exógena y de facturación electrónica reportada por terceros, ha puesto a su disposición 
        la Declaración Sugerida de Renta correspondiente al año gravable. </p><br>
        <p>Hacer uso de los valores presentados en la declaración sugerida, no constituye impedimento para que la administración tributaria 
        revise la declaración presentada. 
        La presunción de la actuación bajo los principios de confianza legítima y buena fe hacia el contribuyente, 
        no excluye la facultad de la autoridad tributaria para verificar, auditar o analizar la documentación presentada, en cumplimiento de sus 
        atribuciones legales</p><br>
                <div fxLayout="column" class="card-with-bg-blue"><b>Es su responsabilidad</b><br><br><p style="margin-top: 10px">
                 Revisarla en detalle y realizar las modificaciones necesarias para que 
                corresponda con su realidad jurídica, económica y financiera. </p></div>`,
        textButtons: `<p class="text-buttons"><b>¿Desea consultar la declaración sugerida?</b></p>`,
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Sí, consultar",
                class: "general-button",
                value: true
            },
            {
                text: "No, gracias",
                class: "button-outline-border",
                value: false
            }
        ]
    };        

    public static dialogoConfigSinFirma: DataDialog = {
        centerContent: true,
        icon: 'peligro.png',
        title: '<h4 class="title-m-center">&nbsp;&nbsp;No tiene firma electrónica</h4>',
        subtitle: '<p class="center-content">Para agilizar y facilitar su trámite de declaración de<br>renta, le recomendamos generarla.</p>',
        content: '<p class="card-with-bg-blue">La firma se activará aproximadamente, 10<br>minutos despues de su generación</p>',
        textButtons: '',
        orientationButtons: 'vertical',
        buttons: [
            {
                text: "Generar firma",
                class: "general-button",
                value: true
            },
            {
                text: "Continuar sin firma",
                class: "button-outline-border",
                value: false
            }
        ]
    };

    public static dialogoConfigRedirectPago: DataDialog = {
        centerContent: true,
        icon: 'peligro.png',
        title: '',
        subtitle: 'Pago en proceso, será dirigido a la página del<br>banco. ¿Desea continuar?',
        content: '',
        textButtons: '',
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Sí",
                class: "general-button",
                value: true
            },
            {
                text: "No",
                class: "button-outline-border",
                value: false
            }
        ]
    };

    public static dialogoConfigDesautorizarFirma: DataDialog = {
        centerContent: true,
        icon: 'peligro.png',
        title: '',
        subtitle: 'Para editar el formulario, es necesario<br>desautorizar la firma. ¿Desea continuar?',
        content: '',
        textButtons: '',
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Si",
                class: "general-button",
                value: true
            },
            {
                text: "No",
                class: "button-outline-border",
                value: false
            }
        ]
    };

    public static dialogoPresentado: DataDialog = {
        centerContent: true,
        icon: 'exito.svg',
        title: 'Gracias por presentar su declaración.',
        subtitle: '', 
        content: '',
        textButtons: ``,
        orientationButtons: 'horizontal',
        buttons: [
            {
                text: "Cerrar",
                class: "general-button",
                value: true
            }
        ]
    };
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/configuracion/dialog-views-data.ts